import { useCallback } from 'react';
import { useAppDispatch } from 'hooks';
import { updateProfileState as _updateProfileState } from 'actionCreators';

const useUpdateRedux = () => {
  const dispatch = useAppDispatch();

  const updateProfileReduxState = useCallback(
    (params: Record<string, any>) => {
      dispatch(_updateProfileState(params));
    },
    [dispatch],
  );

  return {
    updateProfileReduxState,
  };
};

export default useUpdateRedux;
